import { formatDate } from '@btime/helpers'
import { propEq } from 'ramda'
import { useSessionPermission } from '@btime/react-session'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { ACTIONS } from '../../_constants/actions'
import { genFormattedColumn, useRowActionsColumn } from '../../../../components/tables/Table'
import { sessionsClient } from '../../../../utils/apollo/api'
import { useOpenPublicTokenModal } from '../../../../utils/routes/modals/modalsActions'
import { usePublicTokens } from '../_load/PublicTokensLoader'
import { useRowsActions } from './_actions/rowsActions'
import DataTable from '../../../../packages/kiti/components/table/DataTable'
import Link from '../../../../components/actions/Link'
import SwitchDisabled from '../../../../components/helpers/disabled/SwitchDisabled'
import Text from '../../../../packages/kiti/components/presentation/Text'

const PublicTokensTable = () => {
  const { t } = useTranslation(['publicToken', 'common'])
  const publicTokens = usePublicTokens()
  const canEdit = useSessionPermission('editPublicToken')

  const openDetails = useOpenPublicTokenModal()

  const columns = [
    {
      label: t('common:name'),
      dataIndex: 'name',
      sortIndex: false,
      flex: 5,
      render: (name, record) => (
        <Link onClick={() => openDetails(record.id)}>
          <Text size="xxsmall">{ACTIONS.find(propEq('id', record.action))?.name}</Text>
          <Text bold>{name}</Text>
        </Link>
      )
    },

    {
      label: t('publicToken:availableUses'),
      dataIndex: 'amountLeft',
      sortIndex: false,
      flex: 2
    },

    {
      label: t('publicToken:validUntil'),
      dataIndex: 'expireDate',
      sortIndex: false,
      flex: 2
    },

    {
      label: t('common:createdAt'),
      dataIndex: 'insertedAt',
      sortIndex: 'INSERTED_AT',
      flex: 2,
      render: genFormattedColumn(formatDate('DD/MM/YYYY HH:mm'))
    },

    {
      label: t('publicToken:enabled'),
      dataIndex: 'enabled',
      sortIndex: false,
      flex: 1,
      render: (_, record) => (
        <SwitchDisabled
          client={sessionsClient}
          entity="PublicToken"
          record={record}
          size={'small'}
          disabled={!canEdit}
        />
      )
    },

    {
      label: t('common:actions'),
      flex: 1,
      render: useRowActionsColumn(useRowsActions)
    }
  ]

  return <DataTable rowKey="id" columns={columns} size="medium" data={publicTokens} inPanel />
}

export default PublicTokensTable
